export default __webpack_public_path__ + "static/media/hot-dog.41d352cb.svg";